'use client';

import { c as _c } from "react/compiler-runtime";
import type { ConnectedWalletOperation } from '@morfi/onramp-sdk';
import { type ReactNode, useEffect, useRef, useState } from 'react';
import { logger } from '@/lib/telemetry/logger';
import { FundingProviderLoading } from '../shared/funding-provider-loading';
import { connectedWalletMessage, connectedWalletMessageBinding } from './connected-wallet-widget-message';
const providerSandbox: string = ['allow-scripts', 'allow-same-origin', 'allow-forms', 'allow-popups', 'allow-popups-to-escape-sandbox', 'allow-top-navigation-by-user-activation'].join(' ');
export function FundingConnectedWalletFrame(t0) {
  const $ = _c(19);
  const {
    widget,
    onReady,
    onSuccess,
    onError
  } = t0;
  const frame = useRef(null);
  const [height, setHeight] = useState(580);
  const [ready, setReady] = useState(false);
  let t1;
  let t2;
  if ($[0] !== onError || $[1] !== onReady || $[2] !== onSuccess || $[3] !== widget.allowedOrigin) {
    t1 = () => {
      const listener = event => {
        const activeFrame = frame.current?.contentWindow;
        const binding = connectedWalletMessageBinding(event.origin, event.source, activeFrame, widget.allowedOrigin);
        if (binding === "ignore") {
          return;
        }
        if (binding === "reject") {
          logger.warn("onramp.connected_wallet_message_rejected", {
            stage: "message_binding"
          });
          return;
        }
        const message = connectedWalletMessage(event.data);
        if (!message) {
          return;
        }
        if (message.kind === "ready") {
          setReady(true);
          onReady();
        } else {
          if (message.kind === "height") {
            setHeight(message.height);
          } else {
            if (message.kind === "success") {
              onSuccess();
            } else {
              setReady(true);
              onError();
            }
          }
        }
      };
      window.addEventListener("message", listener);
      return () => window.removeEventListener("message", listener);
    };
    t2 = [widget.allowedOrigin, onReady, onSuccess, onError];
    $[0] = onError;
    $[1] = onReady;
    $[2] = onSuccess;
    $[3] = widget.allowedOrigin;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  if (new URL(widget.url).origin !== widget.allowedOrigin) {
    throw new Error("connected_wallet_invalid_widget_origin");
  }
  let t3;
  if ($[6] !== ready) {
    t3 = !ready ? <div className="absolute inset-0"><FundingProviderLoading /></div> : null;
    $[6] = ready;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = ready ? "block w-full border-0" : "block w-full border-0 opacity-0";
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setReady(true);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onError) {
    t6 = () => {
      setReady(true);
      logger.warn("onramp.connected_wallet_frame_failed", {
        stage: "load"
      });
      onError();
    };
    $[9] = onError;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== height || $[12] !== t4 || $[13] !== t6 || $[14] !== widget.url) {
    t7 = <iframe ref={frame} title="MoonPay Connect Wallet" src={widget.url} allow="camera; clipboard-write; payment" sandbox={providerSandbox} height={height} className={t4} onLoad={t5} onError={t6} />;
    $[11] = height;
    $[12] = t4;
    $[13] = t6;
    $[14] = widget.url;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t3 || $[17] !== t7) {
    t8 = <div className="relative w-full">{t3}{t7}</div>;
    $[16] = t3;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}